<template>
    <div
        id="collapseEl"
        class="toggleBtnDefault exchangeBtnDefault"
        v-bind:class="{ _euroSiteStyle: isEuroSite }"
    >
        <div v-if="isEuroSite" class="toggleBtnGroup">
            <button
                type="button"
                class="toggleBtn"
                v-bind:class="{
                    _expand: !status,
                    JARVIS_SportPage_Btn_ExpandList: !status,
                    JARVIS_SportPage_Btn_CollapseList: status,
                }"
                v-on:click="changeStatus()"
            >
                <Icons v-bind:iconName="status ? 'systemIcon_collapseList' : 'systemIcon_expandList'" />
                <span v-if="!isEuroSite">{{ i18n.t(status ? collapseKey : expandKey) }}</span>
            </button>

            <button
                v-if="!isMoreMarket"
                type="button"
                class="toggleBtn JARVIS_SportPage_Btn_Filter"
                v-bind:class="{ 'active JARVIS_SportPage_Btn_Filtered': hasFilter }"
                v-on:click="toggleFilter"
            >
                <Icons iconName="systemIcon_filter" />
                <span
                    v-if="hasFilter"
                    class="LeagueFilter-listItem-checkbox _selected"
                >
                    <Icons iconName="systemIcon_checked" />
                </span>
            </button>
        </div>
        <div v-else class="operationalGroup">
            <button
                type="button"
                class="operationalBtn"
                v-bind:class="{
                    JARVIS_SportPage_Btn_ExpandList: !status,
                    JARVIS_SportPage_Btn_CollapseList: status,
                }"
                v-on:click="changeStatus()"
            >
                <Icons
                    class="iconsSize-24"
                    v-bind:iconName="status ? 'systemIcon_arrowsToLine' : 'systemIcon_arrowsFromLine'"
                />
            </button>
            <button
                v-if="!isMoreMarket"
                type="button"
                v-bind:class="{
                    'operationalBtn-focus': hasFilter,
                }"
                class="operationalBtn JARVIS_SportPage_Btn_Filter"
                v-on:click="toggleFilter"
            >
                <Icons
                    class="iconsSize-24"
                    iconName="systemIcon_filter_new"
                />
                <span
                    v-if="hasFilter && filteredLeagueCount > 0"
                    class="counts"
                >
                    <span>{{ filteredLeagueCount }}</span>
                </span>
            </button>
        </div>
        <div
            v-if="isExchangeEnabled"
            class="accentBtn Cricket_Btn_Exchange Cricket_Btn_Exchange_View"
            v-on:click="goToExchange"
        >
            <Icons iconName="systemIcon_exchange_icon" />
            <span>Exchange</span>
        </div>

        <div
            v-else-if="isWorldCupEntranceVisible"
            class="collapseTcEntrance TC_SportPage_Entrance"
            role="link"
            tabindex="0"
            v-on:click="goToTournamentCenter"
            v-on:keydown.enter="goToTournamentCenter"
        >
            <span class="collapseTcEntrance-bg" aria-hidden="true">
                <span class="collapseTcEntrance-sky" />
                <span class="collapseTcEntrance-crowd" />
                <span class="collapseTcEntrance-light" />
                <span class="collapseTcEntrance-pitch" />
                <span
                    v-for="(speck, index) in confetti"
                    v-bind:key="index"
                    class="collapseTcEntrance-confetti"
                    v-bind:style="{
                        left: speck.left,
                        top: speck.top,
                        width: `${speck.w}px`,
                        height: `${speck.h}px`,
                        background: speck.color,
                        transform: `rotate(${speck.rot}deg)`,
                    }"
                />
            </span>

            <span class="collapseTcEntrance-content">
                <span class="collapseTcEntrance-main">
                    <span class="collapseTcEntrance-title">
                        {{ i18n.t('tournament_center_event_title') }}
                    </span>
                    <span class="collapseTcEntrance-teams">
                        <picture v-if="homeTeamLogo" class="collapseTcEntrance-flag">
                            <source
                                v-bind:srcset="homeTeamLogo.webp"
                                type="image/webp"
                            >
                            <img
                                v-bind:src="homeTeamLogo.origin"
                                alt=""
                                aria-hidden="true"
                            >
                        </picture>
                        <span class="collapseTcEntrance-vs">vs</span>
                        <picture v-if="awayTeamLogo" class="collapseTcEntrance-flag">
                            <source
                                v-bind:srcset="awayTeamLogo.webp"
                                type="image/webp"
                            >
                            <img
                                v-bind:src="awayTeamLogo.origin"
                                alt=""
                                aria-hidden="true"
                            >
                        </picture>
                    </span>
                </span>

                <span v-if="isFirstEventLive" class="collapseTcEntrance-live">
                    {{ liveLabel }}
                </span>
                <span v-else class="collapseTcEntrance-kick">
                    <span class="collapseTcEntrance-kickLabel">
                        {{ isKickOffCrossDay ? kickOffDate : i18n.t('tournament_center_entrance_kick_off') }}
                    </span>
                    <span class="collapseTcEntrance-kickTime">{{ kickOffTime }}</span>
                </span>

                <svg
                    class="collapseTcEntrance-arrow"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                >
                    <path
                        d="M9 6l6 6-6 6"
                        stroke="currentColor"
                        stroke-width="2.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </span>
        </div>
        <div
            v-else-if="isMuayThaiOneBxEntranceVisible"
            class="goMuayThaiOneBx accentBtn JARVIS_SportPage_Btn_MuayThaiOneBx"
            v-on:click="redirectToMuayThaiOneBx"
        >
            <span>{{ i18n.t('sportType_MuayThaiOneBx') }}</span>
            <Icons class="iconsSize-16" iconName="systemIcon_arrowRight" />
        </div>
        <div
            v-else-if="isVirtualSportsEnable"
            v-bind:class="`goVirtualSports accentBtn JARVIS_SportPage_Btn_${getSportTypeKey(getVirtualSports)}`"
            v-on:click="switchToVirtualSports(getVirtualSports)"
        >
            <span>{{ i18n.t(`sportType_${(getSportTypeKey(getVirtualSports))}`) }}</span>
            <Icons class="iconsSize-16" iconName="systemIcon_arrowRight" />
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed, defineComponent, onMounted } from 'vue';
    import { useRouter } from 'vue-router';
    import useTournamentCenterEntrance from '@/components/tournamentCenter/entrance/useTournamentCenterEntrance';
    import { MarketPage, RoutePage, SportType } from '@/interface/enum';
    import { useApp } from '@/libraries/composables/useApp';
    import useScroll from '@/libraries/composables/useScroll';
    import { useSportsList } from '@/libraries/composables/useSportsList';
    import { useZone } from '@/libraries/composables/useZone';
    import { getTranslationBySite } from '@/libraries/helpers/i18nHelper';
    import { platform } from '@/libraries/helpers/platformHelper';
    import { formatShowTime } from '@/libraries/helpers/showTimeHelper';
    import { getSportTypeKey } from '@/libraries/helpers/sportsHelper';
    import { getTournamentTeamImage } from '@/libraries/helpers/tournamentCenterHelper';
    import { i18n } from '@/libraries/i18n';
    import { useTournamentCenterEntranceEvents } from '@/libraries/oddsApi/composables/useTournamentCenterEntranceEventsQuery';
    import { useAccountStore } from '@/stores/accountStore';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';
    import { useRootStore } from '@/stores/rootStore';
    import Icons from '@/svg/Icons.vue';

    export default defineComponent({
        name: 'Collapse',
        components: {
            Icons,
        },
        emits: ['changeStatus', 'toggleFilter'],
        props: {
            status: {
                type: Boolean,
                default: true,
            },
            collapseKey: {
                type: String,
                default: '',
            },
            expandKey: {
                type: String,
                default: '',
            },
            isShowButton: {
                type: Boolean,
                default: true,
            },
            isMoreMarket: {
                type: Boolean,
                default: true,
            },
        },
        setup(props, context) {
            onMounted(() => {
                const { initHeaderDisplayHeight } = useScroll();
                initHeaderDisplayHeight(() => document.getElementById('collapseEl'), 'collapseHeight');
            });

            const { isAsi, sportType, marketPage, hasFilter, filter } = storeToRefs(useRootStore());
            const { isVsSportSwitchEnabled, isEuroSite, isFairExchangeEnabled, tournamentCenterMainLeagueIds } = storeToRefs(useFeatureToggleStore());

            const filteredLeagueCount = computed(() => filter.value?.leagueIds.length ?? 0);

            const { isInAnyZone, isTournamentCenterZone } = useZone();

            const { switchToVirtualSports, isOneBxAvailable, redirectToMuayThaiOneBx } = useSportsList();

            const getVirtualSports = computed(() => {
                const map: Partial<Record<SportType, SportType>> = {
                    [SportType.Soccer]: SportType.VirtualFootball,
                    [SportType.Basketball]: SportType.VirtualNBA,
                };
                return map[sportType.value] ?? SportType.Unknown;
            });

            const { isCurrencyInList, isIpCountryInList } = useAccountStore();
            const isIndiaUser = computed(() => isCurrencyInList(['INR']));
            const isThailandUser = computed(() => isCurrencyInList(['TB']) || isIpCountryInList(['TH']));
            const isExchangeEnabled = computed(() => !props.isMoreMarket && sportType.value === SportType.Cricket && isFairExchangeEnabled.value);
            const { isFromApp } = useApp();
            const isVirtualSportsEnable = computed(() => {
                if (isInAnyZone.value) {
                    return false;
                }
                return isAsi.value && isVsSportSwitchEnabled.value
                    && !props.isMoreMarket && !isIndiaUser.value
                    && !!getVirtualSports.value && !isFromApp;
            });

            const isMuayThaiOneBxEntranceVisible = computed(() => {
                if (isInAnyZone.value) {
                    return false;
                }
                return isAsi.value
                    && !props.isMoreMarket && isThailandUser.value
                    && isOneBxAvailable.value && !isFromApp
                    && ![SportType.Basketball, SportType.Soccer].includes(sportType.value);
            });

            function changeStatus() {
                context.emit('changeStatus');
            }

            function toggleFilter() {
                window.scrollTo(0, 0);
                context.emit('toggleFilter');
            }

            const { route: tournamentCenterRoute, isShowTournamentCenterMainPageEntrance } = useTournamentCenterEntrance();

            const { events } = useTournamentCenterEntranceEvents({
                sportType: SportType.Soccer,
                isMixParlayMode: false,
                tournamentIds: tournamentCenterMainLeagueIds.value,
                isEnabled: computed(() => isShowTournamentCenterMainPageEntrance.value),
                isSubScriptionEnabled: false,
            });

            const firstWorldCupEvent = computed(() => events.value[0]);
            const homeTeamLogo = computed(() => (firstWorldCupEvent.value ? getTournamentTeamImage(firstWorldCupEvent.value.homeTeam) : null));
            const awayTeamLogo = computed(() => (firstWorldCupEvent.value ? getTournamentTeamImage(firstWorldCupEvent.value.awayTeam) : null));
            const isFirstEventLive = computed(() => firstWorldCupEvent.value?.isLive ?? false);
            const kickOffTime = computed(() => (firstWorldCupEvent.value ? formatShowTime(firstWorldCupEvent.value.showTime, firstWorldCupEvent.value.showTimeType) : ''));
            const kickOffDate = computed(() => firstWorldCupEvent.value?.eventDate ?? '');
            const isKickOffCrossDay = computed(() => !!firstWorldCupEvent.value && firstWorldCupEvent.value.marketPage !== MarketPage.Today);
            const liveLabel = computed(() => getTranslationBySite('live').toUpperCase());

            const confetti = [
                { left: '8%', top: '16%', w: 4, h: 5, color: '#FFCA00', rot: 24 },
                { left: '22%', top: '34%', w: 3, h: 4, color: '#3DA5FF', rot: 70 },
                { left: '38%', top: '12%', w: 3, h: 5, color: '#FFFFFF', rot: 130 },
                { left: '48%', top: '38%', w: 4, h: 4, color: '#FF7A00', rot: 18 },
                { left: '16%', top: '48%', w: 3, h: 3, color: '#FFFFFF', rot: 45 },
                { left: '44%', top: '26%', w: 3, h: 4, color: '#5BE08A', rot: 150 },
            ];

            const isWorldCupEntranceVisible = computed(() => {
                if (isInAnyZone.value) {
                    return false;
                }

                return isShowTournamentCenterMainPageEntrance.value && !props.isMoreMarket && !isTournamentCenterZone.value && marketPage.value === MarketPage.Live && !!firstWorldCupEvent.value;
            });
            const router = useRouter();

            function goToTournamentCenter() {
                router.push(tournamentCenterRoute.value);
            }

            function goToExchange() {
                if (isAsi.value) {
                    router.push({ name: RoutePage.Exchange });
                } else {
                    platform.showLogin('Sports');
                }
            }

            return {
                i18n,
                isAsi,
                sportType,
                hasFilter,
                getSportTypeKey,
                switchToVirtualSports,
                getVirtualSports,
                isVirtualSportsEnable,
                isMuayThaiOneBxEntranceVisible,
                redirectToMuayThaiOneBx,
                isExchangeEnabled,
                isEuroSite,
                filteredLeagueCount,
                filter,
                changeStatus,
                toggleFilter,
                goToExchange,
                isWorldCupEntranceVisible,
                homeTeamLogo,
                awayTeamLogo,
                isFirstEventLive,
                kickOffTime,
                kickOffDate,
                isKickOffCrossDay,
                liveLabel,
                confetti,
                goToTournamentCenter,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/collapse";

.exchangeBtnDefault {
    align-items: center;
}

.operationalGroup {
    display: flex;
    flex: 1;
}

.operationalBtn {
    display: flex;
    align-items: center;
    padding: 0.4rem;
    margin-right: 0.4rem;
    background-color: transparent;
    color: $brandColor-800;
    pointer-events: auto;

    &.operationalBtn-focus {
        background-color: rgba($color: $brandColor-800, $alpha: 8%);
        border-radius: 3px;
    }
}

.counts {
    display: flex;
    height: 16px;
    align-items: center;
    justify-content: center;
    padding: 0.2rem 0.4rem;
    margin-right: 0.4rem;
    margin-left: 0.4rem;
    background-color: $brandColor-800;
    border-radius: 3px;
    color: $white;
    font-size: 12px;
    font-weight: 700;
}
</style>
